import { getComputerMenuQueryOptions } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/useComputerMenu.js';
import { usePrefetchInfiniteQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
export function useComputerMenuPrefetch({ collectionUuid, sideChatAvailable = false, }) {
    const { locale } = useIntl();
    usePrefetchInfiniteQuery({
        ...getComputerMenuQueryOptions({
            collectionUuid,
            locale,
            reason: 'computer-menu-prefetch',
            sideChatAvailable,
        }),
        pages: 1,
    });
}
//# sourceMappingURL=useComputerMenuPrefetch.js.map